import React from 'react'
import { fontGraphik, mq } from '../../utils'
import { IProps } from './index'

import allInOneArrow from '../../images/pricing_tab_arrows/all-in-one.svg'
import leftArrow from '../../images/pricing_tab_arrows/left_arrow.svg'
import middleArrow from '../../images/pricing_tab_arrows/middle_arrow.svg'
import rightArrow from '../../images/pricing_tab_arrows/right_arrow.svg'

export class PricingPageSolutionTabsHelp extends React.PureComponent<IProps> {
  render() {
    const { allInOneHelpText, otherSolutionsHelpText } = this.props
    return (
      <div className="row">
        <div className="box flex">
          <div>
            <img src={allInOneArrow} alt="" className="arrow all-in-one-arrow" />
          </div>
          <div className="text all-in-one-text">{allInOneHelpText}</div>
        </div>
        <div>
          <div className="three-arrow-grid">
            <div className="arrow">
              <img src={leftArrow} alt="" className="arrow left-arrow" />
            </div>
            <div>
              <div className="text specific-text">{otherSolutionsHelpText}</div>
              <div className="middle-arrow">
                <img src={middleArrow} alt="" className="arrow center-arrow" />
              </div>
            </div>
            <div className="arrow">
              <img src={rightArrow} alt="" className="arrow right-arrow" />
            </div>
          </div>
        </div>
        <style jsx>
          {`
            .row {
              display: none;
              grid-template-columns: 1fr 3fr;
              max-width: 1256px;
              margin: 0 auto;
              padding: 0 2%;
              height: 0px;
            }

            @media (${mq.tablet}) {
              .row {
                display: grid;
              }
            }

            .three-arrow-grid {
              display: grid;
              grid-template-columns: 1fr 3fr 1fr;
            }

            .left-arrow {
              margin-left: 55%;
              margin-right: auto;
              display: block;
              margin-top: 16px;
              height: 50px;
            }

            .all-in-one-arrow {
              padding-top: 10px;
              padding-right: 15px;
              height: 89px;
            }

            .right-arrow {
              margin-right: 70%;
              margin-left: auto;
              display: block;
            }

            .center-arrow {
              margin-left: auto;
              margin-right: auto;
              margin-top: 8px;
              display: block;
            }

            @media (${mq.laptop}) {
              .arrow {
                height: 100%;
              }
              .left-arrow {
                height: 58px;
                margin-left: 90%;
                margin-top: 14px;
              }

              .all-in-one-arrow {
                height: 105px;
              }

              .right-arrow {
                margin-right: 95%;
              }
            }

            .box {
              height: 170px;
            }

            .text {
              line-height: 143%;
              text-align: center;
              font-family: ${fontGraphik};
              font-size: 16px;
            }

            .all-in-one-text {
              flex: 0 auto;
              min-width: 181px;
              max-width: 250px;
            }

            .specific-text {
              min-width: 300px;
            }

            .flex {
              display: flex;
            }

            .rows {
              flex-direction: column;
            }
          `}
        </style>
      </div>
    )
  }
}
